<style scoped>
   .loading-hiden {
        display: none;
    }

    .loading-show {
        display: contents;
    }

    .first {
        float: left;
        margin-right: 1em;
    }

    .price {
        float: right;
        margin-left: 1em;
    }

    .list:after {
        content: '';
        border-bottom: dotted;
        display: block;
        overflow: hidden;
        height: 0.6em;
    }

    #invoice-POS {
        box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
        padding: 2mm;
        margin: 0 auto;
        width: 80mm;
        background: #FFF;

    }

    h1 {
        font-size: 1.5em;
        color: #222;
    }

    h2 {
        font-size: .9em;
    }

    h3 {
        font-size: 1.2em;
        font-weight: 300;
        line-height: 2em;
    }

    p {
        font-size: 13px;
        color: #000;
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
        /*font-family: 'JuneBug';*/
        /*line-height: 1.2em;*/
    }

    #top,
    #mid,
    #bot {
        /* Targets all id with 'col-' */
        border-bottom: 1px solid #EEE;
    }

    #top {
        min-height: 100px;
    }

    #mid {
        min-height: 80px;
    }

    #bot {
        min-height: 50px;
    }

    .info {
        display: block;
        float: left;
        margin-left: 0;
    }

    .title {
        float: right;
    }

    .title p {
        text-align: right;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    td {
        padding: 5px 0 5px 15px;
        border: 1px solid #EEE
    }

    .tabletitle {
        padding: 5px;
        font-size: .5em;
        background: #EEE;
    }

    .service {
        border-bottom: 1px solid #EEE;
    }

    .item {
        width: 24mm;
    }

    .itemtext {
        font-size: .5em;
    }

    #legalcopy {
        margin-top: 5mm;
    }

    .hh_p {
        font-size: 14px !important;
    }

    .head-text {
        /*font-size: 30px;*/
        font-weight: 600;
    }
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Add Package</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <form>
            <div class="row">

                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <p class="card-title">Package Actors</p>
                            <h5 class="text-primary">
                                Sender, Receiver and Transporter should use the same phone number every time for better
                                records keeping.
                            </h5>
                            <div class="row">
                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="form-label">Sender name *</label>
                                        <input v-model="parcel_form.sender_name" class="form-control" maxlength="60"
                                            required type="text" placeholder="fullname">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Sender phone *</label>
                                        <input v-model="parcel_form.sender_phone" class="form-control" maxlength="40"
                                            required type="text" placeholder="0xxxxxxxxx">
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="form-label">Receiver name *</label>
                                        <input v-model="parcel_form.receiver_name" class="form-control" maxlength="60"
                                            required type="text" placeholder="fullname">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Receiver phone *</label>
                                        <input v-model="parcel_form.receiver_phone" class="form-control" maxlength="40"
                                            required type="text" placeholder="0xxxxxxxxx">
                                    </div>
                                </div>

                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="form-label">Transporter name (option)</label>
                                        <input v-model="parcel_form.transporter_name" class="form-control"
                                            maxlength="60" required type="text" placeholder="fullname">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Transporter phone (option)</label>
                                        <input v-model="parcel_form.transporter_phone" class="form-control"
                                            maxlength="40" required type="text" placeholder="0xxxxxxxxx">
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <p class="card-title">Package Details</p>

                            <div class="row">
                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="form-label">Package Label *</label>
                                        <input v-model="parcel_form.name" class="form-control" maxlength="100" required
                                            type="text" placeholder="item label">
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Package value *</label>
                                        <!--input v-model="parcel_form.package_value" class="form-control" maxlength="40"
                                            required type="number" placeholder="10000"-->
                                            <input
    :value="formatMoney(parcel_form.package_value)"
    @input="updateMoney('package_value', $event)"
    class="form-control"
    maxlength="40"
    required
    type="text"
    inputmode="numeric"
    placeholder="10000"
>
                                    </div>
                                </div>


                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="form-label">Package Name *</label>
                                        <select v-model="parcel_form.package_tag" class="form-select form-control">
                                            <option v-for="tag in tags" :key="tag.id" :value="tag.id">
                                                {{ tag.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Package Size *</label>
                                        <select v-model="parcel_form.package_size" class="form-select form-control">
                                            <option value="S">S</option>
                                            <option value="R">R</option>

                                        </select>
                                    </div>

                                </div>

                                <div class="col-sm-6 col-md-4">

                                    <div class="form-group">

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <p class="card-title">Shipping Details</p>
                            <div class="row">
                                <div class="col-sm-6 col-md-4">
                                    <div class="form-group">
                                        <label class="">Destination (Location Branch) *</label>
                                        <div class="d-flex">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Enter letter">
                                            <select v-model="parcel_form.branch_to" class="form-select form-control">

                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>

                                            </select>

                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Specify location (option)</label>
                                        <input v-model="parcel_form.specific_location" class="form-control"
                                            maxlength="60" required type="text" placeholder="Arusha maji ya chai">
                                    </div>



                                </div>

                                <div class="col-sm-6 col-md-4">

                                    <div class="form-group">
                                        <label class="form-label">Transportation Price *</label>
                                        <!--input v-model="parcel_form.price" class="form-control" maxlength="40" required
                                            type="number" placeholder="1000"-->
                                            <input
    :value="formatMoney(parcel_form.price)"
    @input="updateMoney('price', $event)"
    class="form-control"
    maxlength="40"
    required
    type="text"
    inputmode="numeric"
    placeholder="1000"
>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Description (option)</label>
                                        <textarea v-model="parcel_form.description" class="form-control" rows="1"
                                            style="width: 100% !important;"
                                            placeholder="Any additional details…"></textarea>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-12">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4">

                                        </div>
                                        <div class="col-sm-12 col-md-4">
                                            <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                                            <button type="button" @click="createParcel"
                                                class="btn btn-primary w-100 mt-2">Submit
                                                Package</button>
                                        </div>
                                        <div class="col-sm-12 col-md-4">

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>

    <div class="modal fade mobile-full-width" id="receiptModal" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" role="dialog" aria-labelledby="receiptModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="container mt-3 mb-3">
                <center>
                    <h3 class="mt-2 mb-3 head-text text-success">Package sent Successfully, You may Print Receipt</h3>
                </center>

                <div class="" id="printThis">


                    <div class="pb-5" id="invoice-POS">
                        <center>
                            <!--img src="/images/new_logo.png" width="250px" alt="logo"-->
                             <h1>USIRI<br/> 
                             TRANSIPORTATION<br/> 
                    SERVICES LIMITED<br/> TIN 154-477-365
                            </h1>
                            <h5 id="pno"></h5>
                        </center>
                        <div>
                            <h5 id="pp"></h5>
                            <center>
                            <img id="codedata-img"
                                src=""
                                alt="" srcset="">
                            </center>
                            <center>
                                <p>TERMS & CONDITIONS</p>
                                <p>Mizigo ya Kuvunjika na Vimiminika sio Dhamana yetu!<br/>
                                   Endapo mzigo utapotea Kampuni italipa kulingana na Thamani
                                   iliyoandikwa kwenye Risiti tuu.
                                </p>
                                
                                <p><br/></p>
                                <p>Asante kwa kutuchagua<br>
                                    TRUST FIRST
                                </p>
                                <p id="ct"></p>
                                <br/>
                                <p><i>Developed by Akilikubwa Digital<br>
                                www.akilikubwadigital.com<br>
                                <p>-----------------------</p>
                                </i>
                                </p>
                                <br>
                            </center>

                        </div>

                    </div><!--End Invoice-->

                </div>
                <div class="d-flex justify-content-center mt-3">
                    <button class="btn btn-primary" @click="printReceipt" id="on_print"><i class="fa fa-printer"></i>Print</button>
                    <span class="m-3"> </span>
                    <button
    id="cancel"
    type="button"
    class="btn btn-danger"
    data-bs-dismiss="modal"
>
    Cancel
</button>
                </div>

            </div>

        </div>
    </div>
</div>

</template>
<script>
import axios from "axios";

import printJS from 'print-js';

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            errors: "",
            tags: [],
            branches: [],
            og_branches: [],
            filter_branch: "",
            parcel_form: {
                sender_name: "",
                sender_phone: "",
                receiver_name: "",
                receiver_phone: "",
                transporter_name: "",
                transporter_phone: "",
                name: "",
                price: 0,
                branch_to: "",
                description: "",
                package_value: 0,
                package_size: "S",
                package_weight: 1,
                package_tag: "",
                specific_location: ""
            },
            parcel:{},
            user: this.$attrs.user
        };
    },
    methods: {

        formatMoney(value) {
        if (value === null || value === undefined || value === "") {
            return "";
        }

        return Number(value).toLocaleString("en-US");
    },

    updateMoney(field, event) {
        // Remove commas and anything that isn't a number
        let value = event.target.value.replace(/,/g, "").replace(/\D/g, "");

        // Store as integer
        this.parcel_form[field] = value ? Number(value) : "";
    },

        async createParcel() {


            this.loading = true

            var parcel_form = this.parcel_form

            var response = await axios
                .post(this.$store.state.api_url + "/parcel/create", parcel_form)
                .catch((errors) => {
                      this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                 this.loading = false
                var parcel = response.data.parcel;

                         const modal = bootstrap.Modal.getOrCreateInstance(
    document.getElementById("receiptModal")
);

modal.show();
               //console.log(parcel)

                var shipping_at = parcel.shipping_at.split('T')
                    var arive_at = parcel.arive_at.split('T')

                    var pp = "<br>"
                    pp += "Route :" + parcel.bb_from_name + " - " + parcel.bb_to_name + "<br>"
                    pp += "Shiping date :" + shipping_at[0] + "<br>"
                    pp += "<br>"
                    pp += "Sender name :" + parcel.sender_name + "<br>"
                    pp += "Sender phone :" + parcel.sender_phone + "<br>"
                    pp += "Receiver name :" + parcel.receiver_name + "<br>"
                    pp += "Receiver phone :" + parcel.receiver_phone
                    pp += "<br><br>"
                    pp += "Package name :" + parcel.name + "<br>"
                    //pp += "Package weight :"+parcel.package_weight+"kg<br>"
                    pp += "Package value :TSH " + parcel.package_value + ".00<br>"
                    pp += "Package size :" + parcel.package_size + "<br>"
                    pp += "Package type :" + parcel.package_tag
                    pp += "<br><br>"
                    pp += "Paid amount :TSH " + parcel.price + ".00"
                    pp += "<br><br>"
                    pp += "Issued by<br>"
                    pp += "Name :" + parcel.fulname + "<br>"
                    pp += "Phone :" + parcel.phone1 + "<br><br>"
                    //pp += "Company phone :0769850631<br>"
                    //pp += "CUSTOMER SERVICES :0752129251<br>"
                    pp += "" + parcel.bb_from_name + " :" + parcel.bb_from_contact + "<br>"
                    pp += "" + parcel.bb_to_name + " :" + parcel.bb_to_contact + "<br>"


                $('#pno').text("Parcel No :" + parcel.id)
                $('#ct').text(parcel.current_time)
                $('#pp').html(pp)
                $('#codedata-img').attr('src', parcel.code_data)
             

                this.parcel_form = {
                sender_name: "",sender_phone: "",receiver_name: "",receiver_phone: "",transporter_name: "",
                transporter_phone: "",name: "",price: 0,branch_to: "",description: "",package_value: 0,
                package_size: "S",package_weight: 1,package_tag: "",specific_location: ""
            }
               
            } else {
                  this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async getOtherBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/other-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = response.data.branches;
                this.og_branches = response.data.branches;

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async getTags() {

            var response = await axios
                .get(this.$store.state.api_url + "/tag/all-tags")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.tags = response.data.tags;

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        printReceipt() {
        printJS({
            printable: 'printThis',
            type: 'html',
            targetStyles: ['*'], // note: targetStyles (plural)
            style: `
                #invoice-POS {
                    width: 80mm;
                }

                #pp {
                    font-family: rockwell;
                    font-size: 30px;
                }

                @page {
                    margin: 0;
                    size: 80mm auto;
                }

                @media print {
                    body {
                        margin: 0;
                        width: 100%;
                        height: auto;
                        font-size: 20px;
                    }
                }
            `
        });
    }

    },
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term))
                )

            })

        }
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getOtherBranch()
        this.getTags()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
